/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { Star, MapPin, Users, Bed, Bath, Home } from "lucide-react";
import { Button } from "../../components/UI/Button";
import AmenitiesSection from "../../components/UI/amenities-section";
import ReviewsSection from "../../components/UI/reviews-section";
import PoliciesSection from "../../components/UI/policies-section";
import { useNavigate, useParams } from "react-router-dom";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRange } from "react-date-range";
import { useQuery } from "@tanstack/react-query";
import {
  JSXElementConstructor,
  ReactElement,
  ReactNode,
  ReactPortal,
  useState,
} from "react";
import { differenceInDays } from "../../utils/diferentDays";
import moment from "moment/moment";
import "moment/locale/es";
import { selectPrice, total } from "../../utils/details";
import { URL_API } from "../../config/default";

import perfil from "../../assets/img/usuario-negro.png";
import ubicacion from "../../assets/img/ubicacion.png";
import Galeria from "../../components/UI/Alquiler/Galeria";

import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { EachDayOfInterval } from "../../utils/eachDayOfInterval";
import { Card, CardContent } from "../../components/UI/Card";
import { Qualy } from "../../utils/qualy";
import SEO from "../../components/SEO";
import { Skeleton } from "../../components/UI/Skeleton";
import Error from "../Error/Index";

const Detalle = () => {
  const [showGallery, setShowGallery] = useState(false);

  const openGallery = () => {
    setShowGallery(true);
  };

  /*
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [show360Tour, setShow360Tour] = useState(false);
  const open360Tour = () => {
    setShowGallery(false);
    setShow360Tour(true);
  };
  */

  localStorage.removeItem("reserva");
  const navigate = useNavigate();
  const { slug } = useParams();
  const [huespedes, setHuespedes] = useState<number>(1);

  const customIcon = new L.Icon({
    iconUrl: ubicacion, // URL de tu icono
    iconSize: [32, 32], // Tamaño del icono [ancho, alto]
    iconAnchor: [16, 32], // Punto de anclaje (centro abajo)
    popupAnchor: [0, -32], // Anclaje del popup
  });

  const onReserve = async (e: any, property: any) => {
    console.log(e);

    localStorage.removeItem("reserva");
    property.title = encodeURIComponent(property.title);
    property.description = encodeURIComponent(property.description);
    let fees: any = [];
    property.fees.map((fee: any) => {
      fee = {
        ...fee,
        name: encodeURIComponent(fee.name),
      };
      fees.push(fee);
    });
    property.fees = fees;
    const propertyEncode = JSON.stringify(property);
    const payload: any = {
      excursion: false,
      property: propertyEncode,
      guests: huespedes,
      dateRange: dateRange && dateRange[0],
      differenceDay: differenceInDays(
        dateRange && dateRange[0].startDate,
        dateRange && dateRange[0].endDate
      ),
    };

    localStorage.setItem("reserva", JSON.stringify(payload));
    return navigate("/reservar");
  };

  const [dateRange, setDateRange] = useState<any>(null);

  const { isPending, error, data } = useQuery({
    queryKey: ["alojamiento"],
    queryFn: () => {
      return fetch(`${URL_API}/properties/${slug}`).then(async (res) => {
        const response = await res.json();
        //console.log(response);

        let listHiddenDate = EachDayOfInterval(
          response.data.reservations,
          response.data.dates.map((date: any) => {
            return date.date;
          })
        );

        let startDate =
          listHiddenDate.length > 0
            ? new Date(
              moment(listHiddenDate[listHiddenDate.length - 1])
                .add(1, "day")
                .format("YYYY-MM-DD HH:mm:ss")
            )
            : new Date();
        let endDate =
          listHiddenDate.length > 0
            ? new Date(
              moment(startDate)
                .add(response.data.min_nights, "day")
                .format("YYYY-MM-DD HH:mm:ss")
            )
            : new Date(
              moment()
                .add(response.data.min_nights, "day")
                .format("YYYY-MM-DD HH:mm:ss")
            );

        setDateRange([
          {
            startDate: startDate,
            endDate: endDate,
            key: "selection",
          },
        ]);
        return response;
      });
    },
  });

  if (isPending && !dateRange) {
    return (
      <div className="container mx-auto px-6 lg:px-[50px] py-6">
        {/* Title Section Skeleton */}
        <div className="mb-6">
          <Skeleton className="h-8 w-3/4 mb-2" />
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-40" />
          </div>
        </div>

        {/* Image Gallery Skeleton */}
        <div className="mb-8">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-2 rounded-xl overflow-hidden">
            <div className="lg:col-span-2 lg:row-span-2">
              <Skeleton className="h-64 sm:h-80 lg:h-full" />
            </div>
            <div className="hidden lg:grid lg:col-span-2 grid-cols-2 gap-2">
              <Skeleton className="h-40" />
              <Skeleton className="h-40" />
              <Skeleton className="h-40" />
              <Skeleton className="h-40" />
            </div>
          </div>
        </div>

        {/* Main Content Skeleton */}
        <div className="grid lg:grid-cols-3 grid-cols-1 py-3">
          {/* Left Column */}
          <div className="lg:col-span-2 space-y-8">
            {/* Property Info Skeleton */}
            <div>
              <div className="flex flex-wrap items-center gap-4 mb-4">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-28" />
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-4 w-16" />
              </div>
              <div className="flex items-center gap-3 p-4 border rounded-lg mx-2">
                <Skeleton className="w-10 h-10 rounded-full" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-3 w-24" />
                </div>
              </div>
            </div>

            {/* Description Skeleton */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>

            {/* Amenities Skeleton */}
            <div>
              <Skeleton className="h-6 w-48 mb-4" />
              <div className="grid grid-cols-2 gap-4">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
              </div>
            </div>
          </div>

          {/* Right Column - Booking Card Skeleton */}
          <div className="lg:col-span-1">
            <Card className="shadow-lg border">
              <CardContent className="p-6 space-y-4">
                <Skeleton className="h-6 w-3/4" />
                <div className="space-y-2">
                  <Skeleton className="h-12 w-full" />
                  <Skeleton className="h-12 w-full" />
                </div>
                <Skeleton className="h-12 w-full" />
                <Skeleton className="h-4 w-2/3" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                </div>
                <Skeleton className="h-4 w-full" />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    );
  }

  if (error) return <Error />;

  const url = window.location.href;
  const property = data.data;

  const disabledDays = [
    ...EachDayOfInterval(property.reservations, null),
    ...property.dates.map((date: any) => date.date),
  ];
  /*
  useEffect(() => {
    const call = async () => {
      setState(STATUS.loading);
      const data: IAlquiler | undefined = await callDetail("", id || "");
      setData(data);
      setState(STATUS.success);
    };
    call();
  }, [id]);
  */

  if (showGallery) {
    return (
      <Galeria
        images={property.images}
        show={showGallery}
        onClose={() => setShowGallery(false)}
      />
    );
  }

  return (
    <div className="container mx-auto px-6 lg:px-[50px] py-6">
      <SEO
        title={property.title}
        description={property.description}
        name={`${property.owner.firstname} ${property.owner.lastname}`}
        type="website"
        canonicalUrl={url}
        keywords={`alquiler, ${property.city}, ${property.province}, ${property.type}, alojamiento`}
        image={property?.images.length > 0 ? property.images[0].url : ""}
        twitterHandle="@tu_usuario_twitter"
      />

      {/* Title Section */}
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
          {property.title}
        </h1>
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-sm text-gray-600">
          <div className="flex items-center gap-1">
            <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
            <span className="font-medium">
              {Qualy(property.reviews).total["total"]}
            </span>
            <span>({property.reviews.length} reseñas)</span>
          </div>
          <div className="flex items-center gap-1">
            <MapPin className="w-4 h-4" />
            <span>{property.city}</span>
          </div>
        </div>
      </div>

      {/* Image Gallery */}
      <div className="mb-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-2 rounded-xl overflow-hidden">
          {/* Main Image */}
          <div className="lg:col-span-2 lg:row-span-2">
            <div
              className="relative h-64 sm:h-80 lg:h-full cursor-pointer group"
              onClick={() => openGallery()}
            >
              <img
                src={
                  property?.images.length > 0
                    ? property.images[0].url
                    : "/placeholder.svg"
                }
                alt="Vista principal"
                className="absolute object-cover w-full h-full group-hover:brightness-90 transition-all duration-300"
              />
            </div>
          </div>

          {/* Secondary Images */}
          <div className="hidden lg:grid lg:col-span-2 grid-cols-2 gap-2">
            {property.images.slice(1, 5).map((image: any, index: number) => (
              <div
                key={index}
                className="relative h-40 cursor-pointer group"
                onClick={() => openGallery()}
              >
                <img
                  src={image.url}
                  alt={`Vista ${index + 2}`}
                  className="absolute object-cover w-full h-full group-hover:brightness-90 transition-all duration-300"
                />
                {index === 3 && property.images.length > 5 && (
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                    <span className="text-white font-medium">
                      +{property.images.length - 5} fotos
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Gallery Button */}
        <div className="lg:hidden mt-4">
          <Button
            variant="outline"
            onClick={() => openGallery()}
            className="w-full"
          >
            Ver todas las fotos ({property.images.length})
          </Button>
        </div>

        {/* 360 Tour Button 
        <div className="mt-2 hidden">
          <Button
            onClick={() => setShow360Tour(true)}
            className="w-full bg-[#8B9456] hover:bg-[#7A8249] text-white"
          >
            🏠 Paseo virtual 360°
          </Button>
        </div>
        */}
      </div>

      {/* Main Content */}
      <div className="grid lg:grid-cols-3 grid-cols-1 py-3">
        {/* Left Column */}
        <div className="lg:col-span-2 space-y-8">
          {/* Property Info */}
          <div>
            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mb-4">
              <div className="flex items-center gap-1">
                <Users className="w-4 h-4" />
                <span>{property.travellers} huéspedes</span>
              </div>
              <div className="flex items-center gap-1">
                <Home className="w-4 h-4" />
                <span>{property.bedrooms} dormitorios</span>
              </div>
              <div className="flex items-center gap-1">
                <Bed className="w-4 h-4" />
                <span>{property.beds} camas</span>
              </div>
              <div className="flex items-center gap-1">
                <Bath className="w-4 h-4" />
                <span>{property.bathrooms} baños</span>
              </div>
            </div>

            {/* Host Info */}
            <div className="flex items-center gap-3 p-4 border rounded-lg mx-2">
              <img
                src={property.owner.image ?? perfil}
                alt={`${property.owner.firstname} ${property.owner.lastname}`}
                width={40}
                height={40}
                className="rounded-full"
              />
              <div>
                <div className="font-medium">
                  Anfitrión:{" "}
                  {`${property.owner.firstname} ${property.owner.lastname}`}
                </div>
                <div className="text-sm text-gray-600">
                  Identidad verificada
                </div>
              </div>
            </div>
          </div>

          {/* Description */}
          <div>
            <p className="text-gray-700 leading-relaxed">
              {property.description}
            </p>
          </div>

          {/* Amenities */}
          <AmenitiesSection amenities={property?.services} />

          {/* Stay Period */}
          <div>
            <h2 className="text-xl font-semibold mb-4">
              {`${differenceInDays(
                dateRange && dateRange[0].startDate,
                dateRange && dateRange[0].endDate
              )} noches en ${property.title}`}
            </h2>
            <div className="text-gray-600 mb-4">
              {`${moment(dateRange && dateRange[0].startDate)
                .locale("es")
                .format("D [de] MMMM [de] YYYY")} - ${moment(
                  dateRange && dateRange[0].endDate
                )
                  .locale("es")
                  .format("D [de] MMMM [de] YYYY")}`}
            </div>

            {/* Calendar */}
            <div className="mb-3 px-2">
              <div>
                <div className="py-3 flex lg:hidden">
                  {dateRange ? (
                    <DateRange
                      showDateDisplay={false}
                      // showSelectionPreview={false}
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      onChange={(item: any) => {
                        setDateRange([item.selection]);
                      }}
                      ranges={dateRange}
                      months={1}
                      direction="horizontal"
                      rangeColors={["#414141"]}
                      disabledDates={disabledDays}
                    // locale={locale}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="py-3 lg:flex hidden">
                  {dateRange ? (
                    <DateRange
                      showDateDisplay={false}
                      // showSelectionPreview={false}
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      onChange={(item: any) => {
                        setDateRange([item.selection]);
                      }}
                      ranges={dateRange}
                      months={2}
                      direction="horizontal"
                      rangeColors={["#414141"]}
                      //disabledDates={EachDayOfInterval(property.reservations)}
                      disabledDates={disabledDays}
                    // locale={locale}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <label
                  className="cursor-pointer font-bold"
                  style={{ borderBottom: "1px solid black" }}
                >
                  Borrar fecha
                  <button
                    className="hidden"
                    onClick={() => {
                      setDateRange([
                        {
                          startDate: new Date(),
                          endDate: new Date(
                            moment()
                              .add(property.min_nights, "day")
                              .format("YYYY-MM-DD HH:mm:ss")
                          ),
                          key: "selection",
                        },
                      ]);
                    }}
                  ></button>
                </label>
              </div>

              <div className="hidden">
                {/**<DateSelector bookedDates={accommodationData.bookedDates} /> */}
              </div>
            </div>

            {/* Host Info (Expanded) */}
            <div className="my-6">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={property.owner.image ?? perfil}
                  alt={`${property.owner.firstname} ${property.owner.lastname}`}
                  width={40}
                  height={40}
                  className="rounded-full"
                />
                <div>
                  <div className="font-medium">
                    Anfitrión:{" "}
                    {`${property.owner.firstname} ${property.owner.lastname}`}
                  </div>
                  <div className="text-sm text-gray-600">
                    Identidad verificada
                  </div>
                </div>
              </div>
              <Button variant="outline" className="w-full sm:w-auto">
                Conectar al anfitrión
              </Button>
            </div>

            {/* Reviews */}
            <div className="mb-6">
              <ReviewsSection reviews={property.reviews} />
            </div>

            {/* Location */}
            <div className={JSON.parse(property.show_location) ? "" : "hidden"}>
              <iframe
                src={
                  "https://maps.google.com/?q=" +
                  encodeURI(
                    `${property.address},${property.city} ${property.province} ${property.country}`
                  ) +
                  "&z=14&t=m&output=embed"
                }
                style={{ border: "0" }}
                allowFullScreen={false}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                height="400px"
                className="my-3 w-full hidden"
              ></iframe>

              {JSON.parse(property.lat) && JSON.parse(property.lon) ? (
                <div
                  className="overflow-hidden"
                  style={{ width: "100%", height: "400px", zIndex: 1 }}
                >
                  <MapContainer
                    center={[property.lat, property.lon]}
                    zoom={13}
                    style={{ height: "100%", width: "100%", zIndex: 1 }}
                  >
                    <TileLayer
                      url={
                        "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                      }
                      attribution=""
                    />

                    <Marker
                      position={[property.lat, property.lon]}
                      icon={customIcon}
                    >
                      <Popup>{`${property.address},${property.city} ${property.province} ${property.country}`}</Popup>
                    </Marker>
                  </MapContainer>
                </div>
              ) : (
                ""
              )}
              <span className="block text-md my-2">{`${property.address},${property.city} ${property.province} ${property.country}`}</span>
            </div>
            <div className="hidden">
              {/**<LocationMap location={accommodationData.location} /> */}
            </div>

            {/* Policies */}
            <PoliciesSection property={property} />
          </div>
        </div>

        {/* Right Column - Booking Card */}
        <div className="lg:col-span-1">
          <div className="lg:sticky lg:top-[8rem] fixed bottom-0 left-0 right-0 lg:relative z-50">
            <Card className="shadow-lg border lg:rounded-lg rounded-t-lg rounded-b-none">
              <CardContent className="lg:p-6 p-3">
                <span className="text-2xl font-bold lg:text-[16px] text-[14px]">{`${selectPrice(
                  property.price,
                  property.prices,
                  huespedes
                ).toLocaleString("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} ${property.currency} la noche`}</span>

                <div className="my-1 lg:my-3">
                  <div className="w-full flex items-center">
                    <div className="relative w-full">
                      <div
                        className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder
                        lg:text-[10px] text-[7px]"
                      >
                        CHECK-IN
                      </div>
                      <input
                        name="start"
                        type="date"
                        className="pt-3 lg:pt-5 w-full lg:text-[10px] text-[10px]"
                        value={
                          dateRange &&
                          moment(dateRange[0].startDate).format("yyyy-MM-DD")
                        }
                        style={{
                          borderRadius: "10px 0px 0px 0px",
                          border: "1px solid #E0E0E0",
                        }}
                        disabled
                      />
                    </div>
                    <div className="relative w-full">
                      <div
                        className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder lg:text-[10px] text-[7px]"
                      >
                        CHECK-OUT
                      </div>
                      <input
                        name="start"
                        type="date"
                        value={
                          dateRange &&
                          moment(dateRange[0].endDate).format("yyyy-MM-DD")
                        }
                        className="pt-3 lg:pt-5 w-full lg:text-[10px] text-[10px]"
                        style={{
                          borderRadius: "0px 10px 0px 0px",
                          border: "1px solid #E0E0E0",
                        }}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="relative">
                    <div
                      className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder lg:text-[10px] text-[7px]"
                    >
                      HUÉSPEDES
                    </div>
                    <select
                      id="countries"
                      className="pt-3 lg:pt-5 w-full lg:text-[10px] text-[10px]"
                      style={{
                        borderRadius: "0px 0px 10px 10px",
                        border: "1px solid #E0E0E0",
                      }}
                      onChange={(e) => setHuespedes(Number(e.target.value))}
                    >
                      {Array.from(
                        { length: property.travellers },
                        (_, i) => i + 1
                      ).map((h) => (
                        <option value={h}>{`${h} Adulto`}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="w-full ">
                  <div className="flex justify-center  lg:mb-3">
                    <button
                      className="lg:text-[10px] text-[7px] cursor-pointer btn w-full h-full btn-filled-2 "
                      onClick={(e) => onReserve(e, property)}
                    >
                      Reservar
                    </button>
                  </div>
                  <div className="text-center text-sm text-gray-600 mb-4 lg:text-[10px] text-[10px]">
                    No se te cobrará todavía
                  </div>

                  <div className="flex justify-between  lg:py-3 w-full lg:text-[17px] text-[14px]">
                    <span className="">{`${(
                      selectPrice(property.price, property.prices, huespedes) *
                      differenceInDays(
                        dateRange && dateRange[0].startDate,
                        dateRange && dateRange[0].endDate
                      )
                    ).toLocaleString("de-DE", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })} ${property.currency} por ${differenceInDays(
                      dateRange && dateRange[0].startDate,
                      dateRange && dateRange[0].endDate
                    )} noches`}</span>
                    <span className="text-black font-bold">{`$ ${(
                      selectPrice(property.price, property.prices, huespedes) *
                      differenceInDays(
                        dateRange && dateRange[0].startDate,
                        dateRange && dateRange[0].endDate
                      )
                    ).toLocaleString("de-DE", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })} ${property.currency}`}</span>
                  </div>
                  {property.fees.map(
                    (fee: {
                      price: number;
                      name:
                      | string
                      | number
                      | boolean
                      | ReactElement<any, string | JSXElementConstructor<any>>
                      | Iterable<ReactNode>
                      | ReactPortal
                      | null
                      | undefined;
                    }) => {
                      if (fee.price > 0) {
                        return (
                          <div className="flex justify-between lg:py-2 w-full lg:text-[17px] text-[14px]">
                            <span className="">{fee.name}</span>
                            <span className="text-black font-bold">{`$ ${fee.price.toLocaleString(
                              "de-DE",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )} ${property.currency}`}</span>
                          </div>
                        );
                      }
                    }
                  )}
                </div>
                <hr />
                <div className="flex justify-between lg:py-3 w-full lg:text-[17px] text-[14px]">
                  <span className="">Total</span>
                  <span className="text-black font-bold">{`$ ${total({
                    ...property,
                    price:
                      selectPrice(property.price, property.prices, huespedes) *
                      differenceInDays(
                        dateRange && dateRange[0].startDate,
                        dateRange && dateRange[0].endDate
                      ),
                  }).toLocaleString("de-DE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })} ${property.currency}`}</span>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* 360 Tour Modal 
        show360Tour && (
          <Tour360
            scenes={accommodationData.tour360}
            onClose={() => setShow360Tour(false)}
          />
        )*/}
      </div>
    </div>
  );
};

export default Detalle;

/**
 * 
  return (
    <div className="mx-auto border-0 container md:px-[150px] bg-white">
      <Helmet>
        <title>{`${property.title}`}</title>
        <meta
          name="description"
          content="Descripción para SEO y redes sociales"
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={`${property.title}`} />
        <meta property="og:description" content={`${property.description}`} />
        <meta
          property="og:image"
          content={property?.images.length > 0 ? property.images[0].url : ""}
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={url} />
        <meta name="twitter:title" content={`${property.title}`} />
        <meta name="twitter:description" content={`${property.description}`} />
        <meta
          name="twitter:image"
          content={property?.images.length > 0 ? property.images[0].url : ""}
        />
      </Helmet>
      <label
        className="flex lg:hidden overflow-hidden w-full py-5"
        style={{ height: "300px" }}
      >
        {
          <Carousel
            autoPlay={true}
            showArrows={true}
            showStatus={true}
            showIndicators={false}
            showThumbs={false}
          >
            {property.images.map((img: any, index: number) => {
              return (
                <div
                  className="w-full border  overflow-hidden"
                  style={{ height: "300px" }}
                  key={index}
                >
                  <img
                    src={img.url}
                    alt=""
                    className="w-full h-full object-cover"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </div>
              );
            })}
          </Carousel>
        }
        <button
          className="hidden"
          onClick={() => setModalImagen(true)}
        ></button>
      </label>

      <div className="flex justify-start md:py-5 px-2">
        <Title text={`${property.title}`} link="/#" />
      </div>

      <label
        className="cursor-pointer w-full lg:flex hidden grid grid-cols-2 gap-1 overflow-hidden "
        style={{ height: "500px" }}
      >
        {property.images.map((img: any, index: number) => {
          if (index == 0) {
            return (
              <div
                className="col-span-1 border  overflow-hidden bg-black w-full"
                style={{ height: "500px", borderRadius: "10px 0px 0px 10px" }}
              >
                <img
                  src={img.url}
                  alt=""
                  className="w-full h-full transition-opacity duration-300 hover:opacity-75"
                  style={{
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                  onContextMenu={(e) => e.preventDefault()}
                  draggable="false"
                />
              </div>
            );
          }
        })}

        <div className="col-span-1 w-full">
          <div className="w-full grid grid-cols-2 gap-1 ">
            {property.images.map((img: any, index: number) => {
              if (index == 1 || index == 3) {
                return (
                  <div
                    className="overflow-hidden col-span-1 border bg-black w-full"
                    style={{ height: "250px" }}
                  >
                    <img
                      src={img.url}
                      className="w-full h-full transition-opacity duration-300 hover:opacity-75"
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                      onContextMenu={(e) => e.preventDefault()}
                      draggable="false"
                      alt=""
                    />
                  </div>
                );
              }

              if (index == 2) {
                return (
                  <div
                    className="overflow-hidden col-span-1 border bg-black"
                    style={{
                      height: "250px",
                      borderRadius: "0px 10px 0px 0px",
                    }}
                  >
                    <img
                      src={img.url}
                      className="w-full h-full transition-opacity duration-300 hover:opacity-75"
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                      alt=""
                      onContextMenu={(e) => e.preventDefault()}
                      draggable="false"
                    />
                  </div>
                );
              }

              if (index == 4) {
                return (
                  <div
                    className="overflow-hidden col-span-1 border bg-black"
                    style={{
                      height: "250px",
                      borderRadius: "0px 0px 0px 10px",
                    }}
                  >
                    <img
                      src={img.url}
                      className="w-full h-full transition-opacity duration-300 hover:opacity-75"
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                      alt=""
                      onContextMenu={(e) => e.preventDefault()}
                      draggable="false"
                    />
                  </div>
                );
              }
            })}
          </div>
        </div>

        <button
          className="hidden"
          onClick={() => setModalImagen(true)}
        ></button>
      </label>

      <div className="grid grid-cols-1 lg:grid-cols-4 py-3">
        <div className="col-span-2 px-4">
          <h2 className="font-bold text-2xl">{property.title}</h2>
          <span>{`${property.travellers} huéspedes - ${property.bedrooms} dormitorios -   ${property.beds} camas - ${property.bathrooms} baños`}</span>
          <hr />
          <div className="flex py-[30px]">
            <span className="overflow-hidden block w-[40px] h-[40px] rounded-full me-2 bg-core">
              <img
                src={property.owner.image ?? perfil}
                className="object-cover h-full w-full"
                alt=""
              />
            </span>
            <span className="font-bold text-xl">
              Anfitrión:{" "}
              {`${property.owner.firstname} ${property.owner.lastname}`}
            </span>
          </div>
          <hr />
          <div className="py-4 text-xl text-gray-500">
            {`${property.description}`}
          </div>
          <hr />
          <div>
            <span className="w-48 text-xl font-bold text-black">
              ¿Qué ofrece este lugar?
            </span>
            <div className="w-full text-md font-bol text-black my-4 grid lg:grid-cols-2 grid-cols-1">
              {property.services.map((s: any) => (
                <div className="w-full font-bold text-black mb-1 flex py-2">
                  <img
                    src={servicios.filter((i) => i.name == s.name)[0]?.icon}
                    width={20}
                    className="me-2"
                    alt=""
                  />
                  {s.name}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-span-2 py-3">
          <div className="border shadow-xl px-[10px] lg:px-[50px] py-[50px]">
            <span className="font-bold text-black">{`${selectPrice(
              property.price,
              property.prices,
              huespedes
            ).toLocaleString("de-DE", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${property.currency} la noche`}</span>
            <div className="my-3">
              <div className="flex items-center">
                <div className="relative w-full">
                  <div
                    className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                    style={{ fontSize: "10px" }}
                  >
                    CHECK-IN
                  </div>
                  <input
                    name="start"
                    type="date"
                    className="pt-5 w-full"
                    value={
                      dateRange &&
                      moment(dateRange[0].startDate).format("yyyy-MM-DD")
                    }
                    style={{ borderRadius: "10px 0px 0px 0px" }}
                    disabled
                  />
                </div>
                <div className="relative w-full">
                  <div
                    className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                    style={{ fontSize: "10px" }}
                  >
                    CHECK-OUT
                  </div>
                  <input
                    name="start"
                    type="date"
                    value={
                      dateRange &&
                      moment(dateRange[0].endDate).format("yyyy-MM-DD")
                    }
                    className="pt-5 w-full"
                    style={{ borderRadius: "0px 10px 0px 0px" }}
                    disabled
                  />
                </div>
              </div>
              <div className="relative">
                <div
                  className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                  style={{ fontSize: "10px" }}
                >
                  HUÉSPEDES
                </div>
                <select
                  id="countries"
                  className="pt-5 w-full"
                  style={{ borderRadius: "0px 0px 10px 10px" }}
                  onChange={(e) => setHuespedes(Number(e.target.value))}
                >
                  {Array.from(
                    { length: property.travellers },
                    (_, i) => i + 1
                  ).map((h) => (
                    <option value={h}>{`${h} Adulto`}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="w-full ">
              <div className="flex justify-center">
                <label
                  className="cursor-pointer text-white py-3 px-5 bg-primary mx-auto w-full text-center font-bold hover:opacity-[0.9] transition duration-500"
                  style={{ borderRadius: "10px" }}
                >
                  Reservar
                  <button
                    className="hidden"
                    onClick={(e) => onReserve(e, property)}
                  ></button>
                </label>
              </div>
              <div className="flex justify-between py-3 w-full">
                <span className="">{`${(
                  selectPrice(property.price, property.prices, huespedes) *
                  differenceInDays(
                    dateRange && dateRange[0].startDate,
                    dateRange && dateRange[0].endDate
                  )
                ).toLocaleString("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} ${property.currency} por ${differenceInDays(
                  dateRange && dateRange[0].startDate,
                  dateRange && dateRange[0].endDate
                )} noches`}</span>
                <span className="text-black font-bold">{`$ ${(
                  selectPrice(property.price, property.prices, huespedes) *
                  differenceInDays(
                    dateRange && dateRange[0].startDate,
                    dateRange && dateRange[0].endDate
                  )
                ).toLocaleString("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} ${property.currency}`}</span>
              </div>
              {property.fees.map(
                (fee: {
                  price: number;
                  name:
                    | string
                    | number
                    | boolean
                    | ReactElement<any, string | JSXElementConstructor<any>>
                    | Iterable<ReactNode>
                    | ReactPortal
                    | null
                    | undefined;
                }) => {
                  if (fee.price > 0) {
                    return (
                      <div className="flex justify-between py-2 w-full">
                        <span className="">{fee.name}</span>
                        <span className="text-black font-bold">{`$ ${fee.price.toLocaleString(
                          "de-DE",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )} ${property.currency}`}</span>
                      </div>
                    );
                  }
                }
              )}
            </div>
            <hr />
            <div className="flex justify-between py-3 w-full">
              <span className="">Total</span>
              <span className="text-black font-bold">{`$ ${total({
                ...property,
                price:
                  selectPrice(property.price, property.prices, huespedes) *
                  differenceInDays(
                    dateRange && dateRange[0].startDate,
                    dateRange && dateRange[0].endDate
                  ),
              }).toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} ${property.currency}`}</span>
            </div>
          </div>
        </div>
      </div>

      <hr className="border border-gray my-3" />

      <div className="mb-3 px-2">
        <span className="text-black font-bold">{`${differenceInDays(
          dateRange && dateRange[0].startDate,
          dateRange && dateRange[0].endDate
        )} noches en ${property.title}`}</span>
        <span className="text-black font-bold block">{`${moment(
          dateRange && dateRange[0].startDate
        )
          .locale("es")
          .format("D [de] MMMM [de] YYYY")} - ${moment(
          dateRange && dateRange[0].endDate
        )
          .locale("es")
          .format("D [de] MMMM [de] YYYY")}`}</span>

        <div className="py-3 flex lg:hidden">
          {dateRange ? (
            <DateRange
              showDateDisplay={false}
              // showSelectionPreview={false}
              editableDateInputs={true}
              moveRangeOnFirstSelection={false}
              onChange={(item: any) => {
                setDateRange([item.selection]);
              }}
              ranges={dateRange}
              months={1}
              direction="horizontal"
              rangeColors={["#414141"]}
              disabledDates={disabledDays}
              // locale={locale}
            />
          ) : (
            ""
          )}
        </div>
        <div className="py-3 lg:flex hidden">
          {dateRange ? (
            <DateRange
              showDateDisplay={false}
              // showSelectionPreview={false}
              editableDateInputs={true}
              moveRangeOnFirstSelection={false}
              onChange={(item: any) => {
                setDateRange([item.selection]);
              }}
              ranges={dateRange}
              months={2}
              direction="horizontal"
              rangeColors={["#414141"]}
              //disabledDates={EachDayOfInterval(property.reservations)}
              disabledDates={disabledDays}
              // locale={locale}
            />
          ) : (
            ""
          )}
        </div>
        <label
          className="cursor-pointer font-bold"
          style={{ borderBottom: "1px solid black" }}
        >
          Borrar fecha
          <button
            className="hidden"
            onClick={() => {
              setDateRange([
                {
                  startDate: new Date(),
                  endDate: new Date(
                    moment()
                      .add(property.min_nights, "day")
                      .format("YYYY-MM-DD HH:mm:ss")
                  ),
                  key: "selection",
                },
              ]);
            }}
          ></button>
        </label>
      </div>

      <hr className="border border-gray my-3" />

      <div className="mb-5 px-3">
        <div className="flex py-4">
          <span className="overflow-hidden block w-[40px] h-[40px] rounded-full me-2 bg-core">
            <img
              src={property.owner.image ?? perfil}
              className="object-cover h-full w-full"
              alt=""
            />
          </span>
          <span className="font-bold text-xl">
            Anfitrión:{" "}
            {`${property.owner.firstname} ${property.owner.lastname}`}
          </span>
        </div>
        <span className="block text-gray mb-4">Identidad verificada.</span>
        <label
          className="cursor-pointer bg-primary text-white py-3 px-3 block w-[300px] text-center font-bold hover:opacity-[0.9] transition duration-500"
          style={{ borderRadius: "10px" }}
        >
          Contactar al anfitrión
          <button className="hidden"></button>
        </label>
      </div>

      <hr className="border border-gray my-3" />

      {property.reviews.length > 0 ? (
        <Reseñas reviews={property.reviews} />
      ) : (
        ""
      )}

      <hr className="border border-gray my-3" />

      <div className={JSON.parse(property.show_location) ? "" : "hidden"}>
        <iframe
          src={
            "https://maps.google.com/?q=" +
            encodeURI(
              `${property.address},${property.city} ${property.province} ${property.country}`
            ) +
            "&z=14&t=m&output=embed"
          }
          style={{ border: "0" }}
          allowFullScreen={false}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          height="400px"
          className="my-3 w-full hidden"
        ></iframe>

        {JSON.parse(property.lat) && JSON.parse(property.lon) ? (
          <div
            className="overflow-hidden"
            style={{ width: "100%", height: "400px", zIndex: 1 }}
          >
            <MapContainer
              center={[property.lat, property.lon]}
              zoom={13}
              style={{ height: "100%", width: "100%", zIndex: 1 }}
            >
              <TileLayer
                url={
                  "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                }
                attribution=""
              />

              <Marker position={[property.lat, property.lon]} icon={customIcon}>
                <Popup>{`${property.address},${property.city} ${property.province} ${property.country}`}</Popup>
              </Marker>
            </MapContainer>
          </div>
        ) : (
          ""
        )}
        <span className="block text-md my-2">{`${property.address},${property.city} ${property.province} ${property.country}`}</span>
      </div>

      <hr className="border border-gray my-3" />

      <div className="grid md:grid-cols-3 gap-10 px-2">
        <div>
          <Normas
            content={
              <>
                <span className="block">{`Check-in: ${property.checkin[0].time}`}</span>
                <span className="block">{`Check-out: ${property.checkout[0].time}`}</span>
                <span className="block">{`${property.travellers} huéspedes como máximo`}</span>
                <span className="block hidden">Se permiten mascotas</span>
              </>
            }
            data={property}
          />
        </div>
        <div>
          <Seguridad content={<></>} data={null} />
        </div>
        <div>
          <Politica
            content={
              <>
                <span className="block">
                  Si cancelás antes del 8 de enero, vas a obtener un reembolso
                  parcial.
                </span>
                <span className="block">
                  Consultá la politica de cancelación completa del anfitrion,
                  que se aplica incluso si cancelás por contagio o algún otro
                  problmea causado por el COVID-19
                </span>
                <span className="block">
                  Lago, río u otro cuerpo de agua cercano
                </span>
              </>
            }
            data={null}
          />
        </div>
      </div>
    </div>
  );
 */
